module.exports = __webpack_public_path__ + "static/survey-lifecycle-57f8580ab21d9430d93a738206aa7490.jpg";